import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import { ScalaPreset } from './theme/preset';
import { applyTheme } from './theme';

import './style.css';
import 'primeicons/primeicons.css';

// Resolve the scheme onto <html> — stored preference, else the OS, else dark
// while the token sweep is unfinished (see SWEEP_COMPLETE in ./theme). The
// inline script in index.html has already done this before first paint; this
// call re-affirms it and installs the OS-change listener. `.app-dark` is also
// PrimeVue's darkModeSelector, configured below.
applyTheme();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(PrimeVue, {
  theme: {
    preset: ScalaPreset,
    options: {
      darkModeSelector: '.app-dark',
      cssLayer: false,
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app');
